import { AnimatedIllustrationWrapper } from '../AnimatedIllustrationWrapper';
import type { AnimatedIllustrationProps } from '../types';

export const ComplexityAnimated = ({
  'aria-label': ariaLabel,
  ...props
}: AnimatedIllustrationProps) => {
  return (
    <AnimatedIllustrationWrapper
      src="https://static.mentimeter.com/static/images/animated_illustration_complexity.webp"
      type="spotlight"
      aria-label={ariaLabel || 'Complexity'}
      {...props}
    />
  );
};
